<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<!--pwa no-->
					<pwa-apcn-search-input
						:label="getMessage_('QWCC000969')"
						paramKey="pwaNo"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="4">
					<!--서비스센터-->
					<pwa-apcn-search-input
						:label="getMessage_('QWCC000959')"
						paramKey="dlrCpnyCd"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
				<el-col :span="4">
					<!--차량 VIN-->
					<pwa-apcn-search-input
						:label="getMessage_('QWCC000960')"
						paramKey="carVin"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="4">
					<!--제품 ID-->
					<pwa-apcn-search-input
						:label="getMessage_('QWCC001538')"
						paramKey="pmcId"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>

				<el-col :span="2">
					<!--처리단계-->
					<pwa-apcn-select ref="pwaSelect1" />
				</el-col>

				<el-col :span="2">
					<!--처리결과-->
					<pwa-apcn-select2 ref="pwaSelect2" />
				</el-col>

				
				
			</el-row>
			<el-row :gutter="20">
				<el-col :span="2">
					<!--날짜검색-->
					<pwa-apcn-select3 ref="pwaSelect3" />
				</el-col>
				<!--검색날짜-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC001394')">
						<el-date-picker
							v-model="searchDate"
							@change="changeSearchDate"
							type="daterange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>

				<el-col :span="4">
					<!--신청자-->
					<pwa-apcn-search-input :label="getMessage_('QWCC001251')" paramKey="aplcNm" />
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
import PwaApcnSearchInput from './PwaApcnSearchInput.vue';
import PwaApcnSelect from './PwaApcnSelect.vue';
import PwaApcnSelect2 from './PwaApcnSelect2.vue';
import PwaApcnSelect3 from './PwaApcnSelect3.vue';
import qmsUtils from '@/store/qms/api';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' } //클레임 승인현황에서 날짜 검색조건 가져옴
	},

	data() {
		return {
			searchDate: ['', '']
		};
	},
	components: { PwaApcnSearchInput, PwaApcnSelect, PwaApcnSelect2, PwaApcnSelect3 },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		searchList() {
			this.$sf_toggleLoading(true);
			this.getPwaApcnList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDate(data) {
			let from;
			let to;

			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			} else {
				from = '';
				to = '';
			}

			this.searchDate = [from, to];
			this.setSearchParam_({ key: 'pwaStartDt', value: from });
			this.setSearchParam_({ key: 'pwaEndDt', value: to });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'prcsStepList', codeType: 'PRCS_STEP' });
			await this.getCommCodes_({ key: 'prcsRsltList', codeType: 'PRCS_RSLT' });
			await this.getCommCodes_({ key: 'pwaDdList', codeType: 'PWA_DD' });

			/*클레임 승인내역에서 넘어오는 파라미터 값 시작*/
			let pStartDt = this.pStartDt || '';
			let pEndDt = this.pEndDt || '';
			let pState1 = this.pState1 || ''; // 처리단계
			let pState2 = this.pState2 || ''; // 처리결과
			let pState3 = this.pState3 || ''; // 날짜 검색조건

			pStartDt = pStartDt != '' ? this.$moment(pStartDt).format('YYYY-MM-DD') : '';
			pEndDt = pEndDt != '' ? this.$moment(pEndDt).format('YYYY-MM-DD') : '';

			/*
			console.log('argsState1 >>>>>>', pState1);
			console.log('argsState2 >>>>>>', pState2);
			console.log('argsState3 >>>>>>', pState3);
			console.log('pStartDt >>>>>>', pStartDt);
			console.log('pEnddt >>>>>>', pEndDt);
			*/

			//협력사일경우
			if (this.isMqyStation) {
				let result = await qmsUtils.getDeptNm(this.user.deptCd);

				this.setSearchParam_({ key: 'dlrCpnyCd', value: result.deptCd });
				// this.onChange({key: 'dlrCpnyCd', value: result.deptCd });
				
			} else {
				this.setSearchParam_({ key: 'dlrCpnyCd', value: '' });
			}

			//해당부분 초기화
			this.setSearchParam_({ key: 'prcRsltCd', value: '' });
			this.setSearchParam_({ key: 'prcStepGb', value: '' });
			this.setSearchParam_({ key: 'prcPwaDd', value: '' });
			if (!pStartDt && pEndDt) {
				this.setSearchParam_({ key: 'pwaStartDt', value: this.getStartAplcDd_ });
				this.setSearchParam_({ key: 'pwaEndDt', value: this.getEndAplcDd_ });
				this.searchDate = [this.getStartAplcDd_, this.getEndAplcDd_];
			} else {
				this.setSearchParam_({ key: 'prcRsltCd', value: pState1 });
				this.setSearchParam_({ key: 'prcStepGb', value: pState2 });
				this.setSearchParam_({ key: 'prcPwaDd', value: pState3 });
				this.setSearchParam_({ key: 'pwaStartDt', value: pStartDt });
				this.setSearchParam_({ key: 'pwaEndDt', value: pEndDt });
				this.searchDate = [pStartDt, pEndDt];
			}

			this.$refs.pwaSelect1.processInfo();
			this.$refs.pwaSelect2.processInfo();
			this.$refs.pwaSelect3.processInfo();

			/*클레임 승인내역에서 넘어오는 파라미터 값 끝*/
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
